import Category, { CategoryRequest } from '@/models/Category';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { Categories, CategoryTypes } from './types';

export const getCategoriesRequest = (data: CategoryRequest) => action(CategoryTypes.GET_CATEGORIES_REQUEST, data);
export const getCategoriesSuccess = (categories: Categories, categoriesTotalCountOfRegisters: number) =>
    action(CategoryTypes.GET_CATEGORIES_SUCCESS, {
        categories,
        categoriesTotalCountOfRegisters,
    });
export const getCategoriesFailure = (error: AxiosError) => action(CategoryTypes.GET_CATEGORIES_FAILURE, error);
export const getCategoriesClear = () => action(CategoryTypes.GET_CATEGORIES_CLEAR);

export const getCategoryRequest = (data: number) => action(CategoryTypes.GET_CATEGORY_REQUEST, data);
export const getCategorySuccess = (data: Category) => action(CategoryTypes.GET_CATEGORY_SUCCESS, data);
export const getCategoryFailure = (error: AxiosError) => action(CategoryTypes.GET_CATEGORY_FAILURE, error);
export const getCategoryClear = () => action(CategoryTypes.GET_CATEGORY_CLEAR);

export const toggleCategory = (data: Category) => action(CategoryTypes.TOGGLE_CATEGORY, data);
export const setSelectedCategories = (data: Category[]) => action(CategoryTypes.SET_SELECTED_CATEGORIES, data);
